module.exports = __webpack_public_path__ + "img/dmjqr.65444c64.jpg";